module.exports = __webpack_public_path__ + "img/matmanmatch.cb52eb17.png";